module.exports = __webpack_public_path__ + "img/yz_newMonth_lb.538b8ffb.png";